// Validation patterns
export const BaseValidation = {
    alphaNumeric: /^[a-zA-Z0-9]*$/,
    email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    url: /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/,
    password: /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{6,}$/,
    atleastOneAlphaOneNumeric: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]+$/,
    alphabatic: /^[A-Za-z]+$/,
    nameAlphabatic: /^[A-Za-z ]+$/,
    numeric: /^[0-9]+$/,
    price: /^\d+(\.\d{1,2})?$/, // Allows decimal prices
    specialCharacter: /[!@#$%^&*(),.?":{}|<>]/,
    lowerCharacter: /[a-z]/,
    uppercaseCharacter: /[A-Z]/,
    username: /^[A-Za-z0-9 ]{2,20}$/,
};

// Validation error types
export const errorTypes = {
    required: (fieldName = "This field") => ({
        required: `${fieldName} is required`,
    }),
    email: {
        pattern: {
            value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
            message: "Invalid email address",
        },

    },
    phone: {
        pattern: {
            value: /^[6-9]\d{9}$/, // Indian mobile number validation
            message: "Please enter a valid 10-digit mobile number",
        },
        maxLength: {
            value: 10,
            message: "Mobile number cannot be more than 10 digits",
        },
        minLength: {
            value: 10,
            message: "Mobile number must be exactly 10 digits",
        },
    },
    password: {
        minLength: {
            value: 6,
            message: "Password must be at least 6 characters long",
        },
        pattern: {
            value: BaseValidation.password,
            message:
                "Password must include uppercase, lowercase, number, and special character",
        },
    },
    username: {
        pattern: {
            value: BaseValidation.username,
            message: "Username must be 2-20 characters and only letters, numbers, spaces",
        },
    },
    numeric: {
        pattern: {
            value: BaseValidation.numeric,
            message: "Only numeric values are allowed",
        },
    },
    price: {
        pattern: {
            value: BaseValidation.price,
            message: "Enter a valid price (up to two decimal places)",
        },
    },
    otp: {
        minLength: {
            value: 4,
            message: "OTP must be at least 4 digits",
        },
        pattern: {
            value: BaseValidation.numeric,
            message: "OTP must contain only numbers",
        },
    },
    name: {
        pattern: {
            value: BaseValidation.nameAlphabatic,
            message: "Name must contain only letters and spaces",
        },
        maxLength: {
            value: 160,
            message: "Name should not exceed 160 characters",
        },
    },
    accountNumber: {
        pattern: {
            value: /^[0-9]{9,18}$/,  // Account number must be numeric and between 9 to 18 digits
            message: "Invalid Account Number (must be between 9 to 18 digits)",
        },
    },
    aadhaar: {
        pattern: {
            value: /^[2-9]{1}[0-9]{11}$/,  // Aadhaar must start from 2-9 and be 12 digits
            message: "Invalid Aadhaar Number (must be 12 digits, not starting with 0/1)",
        },
    },
    pan: {
        pattern: {
            value: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,  // PAN must follow AAAAA9999A format
            message: "Invalid PAN format (e.g., ABCDE1234F)",
        },
    },
    uanNumber: {
        pattern: {
            value: /^[0-9]{12}$/,
            message: "UAN must be exactly 12 digits",
        },
    },
    esic: {
        pattern: {
            value: /^[0-9]{10,17}$/,
            message: "ESIC number must be between 10 to 17 digits",
        },
    },
    drivingLicense: {
        pattern: {
            value: /^[A-Z]{2}[0-9]{2}[0-9A-Z]{11,13}$/,
            message: "Invalid Driving License format (e.g., RJ1412345678912)",
        },
    },
    pincode: (fieldName) => ({
        pattern: {
            value: /^[1-9]{1}[0-9]{5}$/,  // Pincode must be exactly 6 digits, starting from 1-9
            message: `Invalid ${fieldName} (must be 6 digits and not start with 0)`,
        },
        minLength: {
            value: 6,
            message: `${fieldName} must be exactly 6 digits`,
        },
        maxLength: {
            value: 6,
            message: `${fieldName} must be exactly 6 digits`,
        },
    }),
};

